import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'matreier-bergfuehrer';

  constructor() {}

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit() {
    const favicon = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (favicon) {
      favicon.href = 'assets/img/favicon-32x32.png';
    }
  }


}
